module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("Foreword by Ian Morgan Cron")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("What You Need to Know")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('a', {
    attrs: {
      "href": "#/p1"
    }
  }, [_vm._v("PART 1"), _c('br'), _vm._v("GROW QUIET—Befriending Your Loneliness")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#enc-002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A LETTER TO MY WIFE—"), _c('br'), _c('span', {
    staticClass: "mev4"
  }, [_vm._v("Before We Belong to Each Other, I Must First Belong to Myself")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1")]), _vm._v(" Abandonment Is Not Loneliness")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2")]), _vm._v(" Neither Is Shame")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3")]), _vm._v(" Nor Is Isolation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4")]), _vm._v(" A Cautionary Note About the Digital Crowd")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5")]), _vm._v(" You Are a Great and Precious Thing")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6")]), _vm._v(" So Learn How to Be Alone")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7")]), _vm._v(" Maybe Even Find God in It")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8")]), _vm._v(" And Let Someone Stand with You for a While")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap11#enc-009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A LETTER TO MY WIFE—"), _c('span', {
    staticClass: "mev4"
  }, [_vm._v("You Are My Destination")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 2"), _c('br'), _vm._v("GROW STRONG—Embracing Your Struggle")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2#enc-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A LETTER TO MY WIFE—"), _c('span', {
    staticClass: "mev4"
  }, [_vm._v("Love Goes the Long Way")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9")]), _vm._v(" Observe Your Protections")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("10")]), _vm._v(" Anger")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("11")]), _vm._v(" Peacefaking")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("12")]), _vm._v(" Certainty")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("13")]), _vm._v(" Yessing")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("14")]), _vm._v(" Competition")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("15")]), _vm._v(" Withdrawal")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("16")]), _vm._v(" Fixing")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("17")]), _vm._v(" Helicoptering")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap12",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("18")]), _vm._v(" And Excitement")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap13#enc-018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A LETTER TO MY WIFE—"), _c('br'), _c('span', {
    staticClass: "mev4"
  }, [_vm._v("Thank You for the Moments Between the Magic")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 3"), _c('br'), _vm._v("GROW OLD—Cherishing Your Time")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap2#enc-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A LETTER TO MY WIFE—"), _c('span', {
    staticClass: "mev4"
  }, [_vm._v("The Whole Thing Is Inconceivable")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("19")]), _vm._v(" Time Isn’t Money, It’s Mortality")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("20")]), _vm._v(" And Remember, Bodies Matter")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("21")]), _vm._v(" So Go Elderly Slow")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("22")]), _vm._v(" Fear (Not) Missing Out")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("23")]), _vm._v(" Laugh Out Loud")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("24")]), _vm._v(" Let Your Memories Gather")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("25")]), _vm._v(" Rust into Something Beautiful")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("26")]), _vm._v(" And Trade Your Strength with Each Other")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("27")]), _vm._v(" Until Death Do You Part")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap12#enc-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A LETTER TO MY WIFE—"), _c('span', {
    staticClass: "mev4"
  }, [_vm._v("A Timeless Reunion")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also Available")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("True Companions")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0